import React from 'react';
import './newscard.scss';
import { NavLink } from 'react-router-dom';
import {  Row, Col } from 'react-bootstrap';
const OfferCards = ({ CardData, Title , showNavLink = true , subTitle , id }) => {

    return (
        <section className='new-wrapper' id={id}>

            <div className='common-heading'>
                <h2>{Title}</h2>
                {showNavLink && <NavLink to="/news">View all news</NavLink>}
            </div>
            <Row>
                {CardData.map((data) => (
                    <Col key={data.id} sm={12} md={4} lg={4} xl={4}>
                        <div className='news-common-card'>
                            {/* Content Section */}
                            <div className='Content'>
                                <div className='subheading'>
                                    <p>{subTitle || 'NEWS'}</p>
                                </div>
                                <div className='Heading'>
                                    <h3>{data.title}</h3>
                                </div>
                                <div className='Text'>
                                    <p>{data.description}</p>
                                </div>
                                <a className='link' href={data.linkUrl}>
                                    <span>{data.linkText}</span>
                                </a>
                            </div>
                        </div>
                    </Col>
                ))}
            </Row>

        </section>
    );
};

export default OfferCards;
